(function () {
    'use strict';

    angular
        .module('app')
        .controller('testpage', testpage);

    testpage.$inject = ['$state', '$http', 'gridDataService', 'folderBrowserService', 'loginService', 'workAreaService', 'clientService', '$q', '$timeout'];

    function testpage($state, $http, gridDataService, folderBrowserService, loginService, workAreaService, clientService, $q, $timeout) {
        /* jshint validthis:true */
        var vm = this;

        vm.getError = function () {
            $http.post('../Synergis.WebApi/testerror');
        }

        vm.loginService = loginService;

        vm.title = 'testpage';

        vm.browseFolder = function () {
            folderBrowserService.show("d:\\workstuff\\qaautomation").then(function (path) {
                console.log(path)
            }, function () {
                console.log("canceled");
            })
        }

        vm.testError = function () {
            workAreaService.testError();
        }


        /*********************** Display  Helper Functions ***********************/
        /*************************************************************************/



        function showHotSpotWindow() {
            parent.document.getElementById('HotSpotsFrameSet').cols = "0,100%";
        }

        vm.getLongTermToken = function () {
            loginService.getLongTermKey().then(function (token) {
                console.log(token);
            });
        }


        vm.testButton = function () {
            DoSomeWork().then(function (response) {
                console.log(response);
            });
        }

        function DoSomeWork() {
            var deferred = $q.defer();

            $timeout(function () {
                alert("Timeout Done");
                deferred.resolve("Some Data");
            }, 3000);


            return deferred.promise;
        }
        
        vm.testACS = function () {
            clientService.get("filesystem/error", true).then(function (result) {
                console.log(result);
            });
        }

        vm.LogoutTest = function () {
            loginService.logOut();
            loginService.logOut();
            loginService.logOut();
            loginService.logOut();
            }

        activate();

        function activate() { }
    }
})();
